import styled from "styled-components/macro";

export const Form = styled.form({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
  width: "100%",
});
